export const MARKETPLACE_SOURCE_ID = 'marketplace'
export const MARKETPLACE_GTTD_SOURCE_ID = 'gttd'
export const SOURCE_KEY = `utm_source`
export const CAMPAIGN_KEY = `utm_campaign`
export const SOURCE_SUFFIX = `${SOURCE_KEY}=${MARKETPLACE_SOURCE_ID}`
export const LONDON = { latitude: 51.5074, longitude: 0.1278 }
